import React from 'react';
import { Card, ListGroup, Button } from 'react-bootstrap';
import { GIOI_TINH, HOC_VI, CHUC_DANH_KH } from '@app/utils/define';
import { formatDateTimeWithoutHour } from '@app/utils/helper';
import { BaseGatewayImage } from '@app/utils/apiUrl';

const ProfileSidebar = ({ 
    nhanVien, 
    tenDonVi,
    isAdmin,
    onPrintV1,
    onPrintV2,
    onEdit,
    onBackToList
}) => {
    return (
        <Card className="shadow-sm border-0 profile-sidebar-card">
            <Card.Body className="text-center">
                <div className="profile-avatar-wrapper mb-3">
                    {nhanVien.hinhAnh ? (
                        <img
                            src={nhanVien.hinhAnh.startsWith('http') ? nhanVien.hinhAnh : BaseGatewayImage + (nhanVien.hinhAnh.startsWith('/') ? '' : '/') + nhanVien.hinhAnh}
                            alt="Avatar"
                            className="profile-avatar-img rounded-circle img-thumbnail"
                            style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                        />
                    ) : (
                        <div className="profile-avatar-placeholder d-flex align-items-center justify-content-center bg-light rounded-circle mx-auto" style={{ width: '120px', height: '120px' }}>
                            <i className="fas fa-user-circle fa-5x text-secondary" style={{ fontSize: '100px' }} />
                        </div>
                    )}
                </div>
                <h4 className="font-weight-bold mb-1 text-primary">{nhanVien.hoTen}</h4>

                <div className="profile-actions-wrapper my-3 d-flex flex-column gap-2">
                    {isAdmin && onBackToList && (
                        <Button 
                            variant="outline-secondary" 
                            size="sm" 
                            className="w-100 mb-2" 
                            onClick={onBackToList}
                            style={{ borderRadius: '20px' }}
                        >
                            <i className="fas fa-arrow-left mr-1" /> Danh sách nhân viên
                        </Button>
                    )}
                    {onEdit && (
                        <Button 
                            variant="outline-success" 
                            size="sm" 
                            className="w-100 mb-2" 
                            onClick={onEdit}
                            style={{ borderRadius: '20px' }}
                        >
                            <i className="fas fa-edit mr-1" /> Sửa thông tin cá nhân
                        </Button>
                    )}
                    <div className="d-flex justify-content-between align-items-center gap-2">
                        {onPrintV1 && (
                            <Button 
                                variant="primary" 
                                size="sm" 
                                className="flex-fill" 
                                onClick={onPrintV1}
                                style={{ borderRadius: '20px', padding: '4px 10px', fontSize: '12px' }}
                            >
                                <i className="fas fa-print mr-1" /> In bản V1
                            </Button>
                        )}
                        {onPrintV2 && (
                            <Button 
                                variant="success" 
                                size="sm" 
                                className="flex-fill ml-2" 
                                onClick={onPrintV2}
                                style={{ borderRadius: '20px', padding: '4px 10px', fontSize: '12px' }}
                            >
                                <i className="fas fa-print mr-1" /> In bản V2
                            </Button>
                        )}
                    </div>
                </div>
                
                <ListGroup variant="flush" className="text-left small">
                    <ListGroup.Item className="px-0 py-2 d-flex justify-content-between">
                        <span className="text-muted"><i className="fas fa-id-card mr-2 text-primary" />CMND/CCCD:</span>
                        <span className="font-weight-bold">{nhanVien.soCMND_CCCD || 'Chưa cập nhật'}</span>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 d-flex justify-content-between">
                        <span className="text-muted"><i className="fas fa-birthday-cake mr-2 text-primary" />Ngày sinh:</span>
                        <span className="font-weight-bold">{formatDateTimeWithoutHour(nhanVien.ngaySinh)}</span>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 d-flex justify-content-between">
                        <span className="text-muted"><i className="fas fa-phone mr-2 text-primary" />Điện thoại:</span>
                        <span className="font-weight-bold">{nhanVien.dienThoaiDiDong || 'Chưa cập nhật'}</span>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 d-flex justify-content-between">
                        <span className="text-muted"><i className="fas fa-envelope mr-2 text-primary" />Email:</span>
                        <span className="font-weight-bold" style={{ wordBreak: 'break-all' }}>{nhanVien.emailCongViec || 'Chưa cập nhật'}</span>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 d-flex justify-content-between">
                        <span className="text-muted"><i className="fas fa-user-tag mr-2 text-primary" />Chức vụ:</span>
                        <span className="font-weight-bold text-right">{nhanVien.chucVu || 'Chưa cập nhật'}</span>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 d-flex justify-content-between">
                        <span className="text-muted"><i className="fas fa-university mr-2 text-primary" />Đơn vị:</span>
                        <span className="font-weight-bold text-right">{tenDonVi || nhanVien.tenDonViTuNhap || 'Chưa rõ'}</span>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 d-flex justify-content-between">
                        <span className="text-muted"><i className="fas fa-graduation-cap mr-2 text-primary" />Học vị:</span>
                        <span className="font-weight-bold">{HOC_VI.find(o => o.value === nhanVien.hocViCaoNhat)?.label || nhanVien.hocViCaoNhat || 'Chưa cập nhật'}</span>
                    </ListGroup.Item>
                    <ListGroup.Item className="px-0 py-2 d-flex justify-content-between">
                        <span className="text-muted"><i className="fas fa-award mr-2 text-primary" />Chức danh KH:</span>
                        <span className="font-weight-bold">{CHUC_DANH_KH.find(o => o.value === nhanVien.chucDanhKHCaoNhat)?.label || 'Không'}</span>
                    </ListGroup.Item>
                    {nhanVien.thongTinIdent && (
                        <ListGroup.Item className="px-0 py-2">
                            <div className="text-muted mb-1"><i className="fas fa-fingerprint mr-2 text-primary" />Định danh khoa học:</div>
                            <div className="font-weight-bold" style={{ wordBreak: 'break-all', fontSize: '11px' }}>{nhanVien.thongTinIdent}</div>
                        </ListGroup.Item>
                    )}
                </ListGroup>
            </Card.Body>
        </Card>
    );
};

export default ProfileSidebar;
